
import service from '@/utils/requestNoToken'

// 客户列表查询
export function getCustomerList(data) {
    return service({
        url: '/qw/customer/list',
        method: 'post',
        data
    })
}

// 反馈新增
export function insertFeedback(data) {
  return service({
      url: '/qw/customer/feedback/insert',
      method: 'post',
      data
  })
}

// 反馈配置二级类型查询
export function feedbackTypeList(params) {
  return service({
      url: '/qw/customer/feedbackTypeList',
      method: 'get',
      params:params
  })
}